module.exports = ".spacer{\n    flex:1 1 auto;\n}\n.nav-bar {\n    height: 70px;\n}"